import React, { Component } from "react";
import _ from "lodash";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import Toolbar from "Utils/Toolbar/Toolbar";
import LoadMask from "Utils/LoadMask/LoadMask";
import { tableOptions } from "Utils/tableOptions";
import { activeFormatter } from "Utils/Acciones/Acciones";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";

import { RenderDateTime } from "Utils/renderField/renderTableField";
import FiltrosPendientes from "../../Filtros/FiltrosPendientes";
import FiltrosCompletados from "../../Filtros/FiltrosCompletados";

class ListadoDespacho extends Component {
    constructor(props) {
        super(props);
    }

    componentWillMount() {
        this.props.setSeleccionados([]);
        this.props.listar(this.props.page);
    }

    // limpiar datos al desmontar el componente
    componentWillUnmount() {
        this.props.limpiar();
    }

    render() {
        // state
        const {
            data,
            loader,
            search,
            tab,
            fecha_compra_final,
            fecha_compra_inicial,
            usuario,
        } = this.props;

        const { fecha_pendiente_inicial, fecha_completado_inicial } =
            fecha_compra_inicial;
        const { fecha_pendiente_final, fecha_completado_final } =
            fecha_compra_final;

        const { usuario_pendiente, usuario_completado } = usuario;

        // bind
        const { anularDespacho, buscar, changeTab, setFecha, setUsuarioValue } =
            this.props;

        const options = _.cloneDeep(tableOptions);
        options.noDataText = loader ? "Cargando..." : options.noDataText;
        options.page = this.props.page;
        options.onPageChange = this.props.listar;
        options.onSortChange = this.props.sortChange;

        return (
            <div className="row mt">
                <div className="col-lg-12 col-md-12 col-sm-12">
                    <Link className="btn btn-primary" to="/traslados/crear/">
                        <em className="fa fa-plus"></em> Nuevo traslado
                    </Link>
                    <Tabs
                        className="content-tabs"
                        selectedIndex={tab == 10 ? 0 : 1}
                        onSelect={(tabIndex) =>
                            changeTab(tabIndex == 0 ? 10 : 20)
                        }
                    >
                        <TabList className="tab_list d-flex flex-row justify-content-between">
                            <Tab
                                className="content-tab-venta flex1 text-center fnt-14"
                                style={{ marginBottom: "0px" }}
                                selectedClassName="content-tab-venta-active"
                            >
                                TRASLADOS PENDIENTES
                            </Tab>
                            <Tab
                                className="content-tab-venta flex1 text-center fnt-14"
                                style={{ marginBottom: "0px" }}
                                selectedClassName="content-tab-venta-active"
                            >
                                TRASLADOS COMPLETADOS
                            </Tab>
                        </TabList>
                        {/* PANEL PENDIENTES */}
                        <TabPanel>
                            <div className="grid-container">
                                <div className="grid-titulo">
                                    <Toolbar
                                        titulo={"Listado"}
                                        buscar={buscar}
                                        search={search}
                                    />
                                </div>
                                {/* //*** Filtros */}
                                <FiltrosPendientes
                                    fecha_pendiente_inicial={
                                        fecha_pendiente_inicial
                                    }
                                    fecha_pendiente_final={
                                        fecha_pendiente_final
                                    }
                                    usuario_pendiente={usuario_pendiente}
                                    setFecha={setFecha}
                                    setUsuarioValue={setUsuarioValue}
                                />
                                <LoadMask loading={loader} dark blur>
                                    <BootstrapTable
                                        data={loader ? [] : data.results}
                                        remote
                                        pagination
                                        hover
                                        fetchInfo={{
                                            dataTotalSize: data.count,
                                        }}
                                        options={options}
                                    >
                                        <TableHeaderColumn
                                            dataField="codigo"
                                            width="120px"
                                            dataFormat={(cell, row) => (
                                                <div>{cell ? cell : ""}</div>
                                            )}
                                        >
                                            Código
                                        </TableHeaderColumn>
                                        <TableHeaderColumn
                                            dataField="sucursal_destino__nombre"
                                            dataFormat={(cell, row) => (
                                                <div>
                                                    {
                                                        row.sucursal_destino
                                                            .nombre
                                                    }
                                                </div>
                                            )}
                                            dataSort
                                        >
                                            Enviado a
                                        </TableHeaderColumn>
                                        <TableHeaderColumn
                                            dataField="creado"
                                            dataFormat={(cell) => (
                                                <RenderDateTime fecha={cell} />
                                            )}
                                            dataSort
                                        >
                                            Fecha
                                        </TableHeaderColumn>
                                        <TableHeaderColumn
                                            dataField="usuario"
                                            dataFormat={(cell, row) => {
                                                if (cell) {
                                                    return cell.first_name;
                                                }
                                                return "---";
                                            }}
                                            dataSort
                                        >
                                            Enviado por
                                        </TableHeaderColumn>
                                        <TableHeaderColumn
                                            isKey
                                            dataField="id"
                                            dataAlign="center"
                                            dataFormat={activeFormatter({
                                                anular: anularDespacho,
                                                ver: "/traslados/visualizacion",
                                            })}
                                        >
                                            Acciones
                                        </TableHeaderColumn>
                                    </BootstrapTable>
                                </LoadMask>
                            </div>
                        </TabPanel>
                        {/* PANEL ENTREGADOS */}
                        <TabPanel>
                            <div className="grid-container">
                                <div className="grid-titulo">
                                    <Toolbar
                                        titulo={"Listado"}
                                        buscar={buscar}
                                        search={search}
                                    />
                                </div>
                                {/* //*** Filtros */}
                                <FiltrosCompletados
                                    fecha_completado_inicial={
                                        fecha_completado_inicial
                                    }
                                    fecha_completado_final={
                                        fecha_completado_final
                                    }
                                    usuario_pendiente={usuario_pendiente}
                                    usuario_completado={usuario_completado}
                                    setFecha={setFecha}
                                    setUsuarioValue={setUsuarioValue}
                                />
                                <LoadMask loading={loader} dark blur>
                                    <BootstrapTable
                                        data={loader ? [] : data.results}
                                        remote
                                        pagination
                                        hover
                                        fetchInfo={{
                                            dataTotalSize: data.count,
                                        }}
                                        options={options}
                                    >
                                        <TableHeaderColumn
                                            dataField="codigo"
                                            width="120px"
                                            dataFormat={(cell, row) => (
                                                <div>{cell ? cell : ""}</div>
                                            )}
                                        >
                                            Código
                                        </TableHeaderColumn>
                                        <TableHeaderColumn
                                            dataField="sucursal_destino__nombre"
                                            dataFormat={(cell, row) => (
                                                <div>
                                                    {
                                                        row.sucursal_destino
                                                            .nombre
                                                    }
                                                </div>
                                            )}
                                            dataSort
                                        >
                                            Enviado a
                                        </TableHeaderColumn>
                                        <TableHeaderColumn
                                            dataField="fecha_recepcion"
                                            dataFormat={(cell) => (
                                                <RenderDateTime fecha={cell} />
                                            )}
                                            dataSort
                                        >
                                            Fecha
                                        </TableHeaderColumn>
                                        <TableHeaderColumn
                                            dataField="usuario"
                                            dataFormat={(cell, row) => {
                                                if (cell) {
                                                    return cell.first_name;
                                                }
                                                return "---";
                                            }}
                                            dataSort
                                        >
                                            Enviado por
                                        </TableHeaderColumn>
                                        <TableHeaderColumn
                                            dataField="recepcionado_por"
                                            dataFormat={(cell, row) => {
                                                if (cell) {
                                                    return cell.first_name;
                                                }
                                                return "---";
                                            }}
                                            dataSort
                                        >
                                            Recibido por
                                        </TableHeaderColumn>
                                        <TableHeaderColumn
                                            isKey
                                            dataField="id"
                                            dataAlign="center"
                                            dataFormat={activeFormatter({
                                                ver: "/traslados/visualizacion",
                                            })}
                                        >
                                            Acciones
                                        </TableHeaderColumn>
                                    </BootstrapTable>
                                </LoadMask>
                            </div>
                        </TabPanel>
                    </Tabs>
                </div>
            </div>
        );
    }
}

ListadoDespacho.propTypes = {
    data: PropTypes.object.isRequired,
    loader: PropTypes.bool.isRequired,
    buscar: PropTypes.func.isRequired,
    sortChange: PropTypes.func.isRequired,
    listar: PropTypes.func.isRequired,
};

export default ListadoDespacho;
